module.exports = __webpack_public_path__ + "img/service3.3606bb71.png";